import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-proud',
  templateUrl: './proud.component.html',
  styleUrls: ['./proud.component.css']
})
export class ProudComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
